import * as React from 'react';
import './link.styles.less';

const Link = ({ children, ...props }: ILinkProps) => (
    <span className="sitegen-link" {...props}>{ children }</span>
);

export interface ILinkProps extends React.ComponentPropsWithoutRef<'span'> {
    readonly children: React.ReactNode;
}

export default Link;